import appClient from "@/services/app/app.client";
import { APP_ENDPOINTS } from "@/services/app/app.constants";
import { createPayload } from "@/services/app/app.utils";

import { TInstallationListRequest, TInstallationListResponse } from "./InstallationSelect.types";

export const getInstallationList = () => {
  return appClient.post<TInstallationListRequest, TInstallationListResponse>(
    APP_ENDPOINTS.BILLING.GET_DASHBOARD_INSTALLATION_LIST,
    createPayload(""),
  );
};
